import { returnNonNull } from 'src/common/helpers/ArraysHelper';

import { MfaIssueQuery } from '../MfaIssue.generated';

export interface IMfaIssueData {
	sessionName: string;
	scanId: string;
	scanName: string;
	shortNodeId: string;
}

export const transformMfaIssueResults = (result: MfaIssueQuery): IMfaIssueData | null => {
	const issues = result.issues?.filter(returnNonNull);

	if (!issues?.length) {
		return null;
	}

	const sessionRuns = result.mfa_session_runs?.filter(returnNonNull);
	const sessionRun = sessionRuns?.[0];
	const issue = issues[0];

	return {
		sessionName: sessionRun?.session_name ?? '',
		scanId: issue.scan_id,
		scanName: issue.scan_name ?? 'Scan 1',
		shortNodeId: issue.elements__index?.[0] ?? '1'
	};
};
